import { StudentField } from '../../../../api/utils/lms/student/api';

/** 화면에서 나눠놓은 정보 영역. 영역 단위로 수정/저장한다. */
export type SectionKey = 'basic' | 'extra' | 'parents';

/**
 * 영역별 수정 대상 필드.
 * - 영역끼리 겹치는 필드가 없어야 한다. (한 영역 저장이 다른 영역 값을 덮어쓰지 않도록)
 * - 검증(trigger) 범위와 저장(params) 범위로 함께 쓰인다.
 * - 입력란이 없는 필드(zipCode)도 주소 검색으로 함께 갱신되므로 저장 대상에 포함한다.
 */
export const SECTION_FIELDS: Record<SectionKey, StudentField[]> = {
  basic: ['englishName', 'birthday', 'gender'],
  extra: [
    'phone',
    'email',
    'address',
    'detailAddress',
    'zipCode',
    'schoolName',
    'schoolGroup',
  ],
  parents: ['parents'],
};
